import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      navigate("/admin");
    } catch {
      toast.error("Invalid email or password.");
    } finally {
      setLoading(false);
    }
  };

  const inputClass =
    "w-full bg-transparent border-b border-[#3a3a3a] focus:border-gold py-3.5 text-white placeholder:text-zinc-600 outline-none transition-colors duration-300";

  return (
    <main className="min-h-screen grid place-items-center px-5 pt-20" data-testid="admin-login-page">
      <div className="w-full max-w-md bg-[#121212] border border-[#27272a] p-8 sm:p-10">
        <div className="h-11 w-11 grid place-items-center border border-gold text-gold mb-6">
          <Lock size={20} />
        </div>
        <span className="font-mono text-xs uppercase tracking-[0.2em] text-gold">
          [ Admin Access ]
        </span>
        <h1 className="font-display text-3xl font-semibold uppercase tracking-tight mt-3 mb-8">
          Inquiry Inbox
        </h1>
        <form onSubmit={submit} className="space-y-7">
          <div>
            <label className="font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-500">
              Email
            </label>
            <input
              type="email"
              className={inputClass}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@…"
              data-testid="admin-email"
            />
          </div>
          <div>
            <label className="font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-500">
              Password
            </label>
            <input
              type="password"
              className={inputClass}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              data-testid="admin-password"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-gold text-black font-mono text-xs uppercase tracking-[0.15em] px-6 py-4 font-semibold hover:bg-[#d59e19] transition-colors duration-300 disabled:opacity-60"
            data-testid="admin-login-submit"
          >
            {loading ? <Loader2 size={16} className="animate-spin" /> : "Sign In"}
          </button>
        </form>
      </div>
    </main>
  );
}
